import { classNamesFunction } from '@fluentui/react';
import * as React from 'react';
import { getverticalBarChartAnimationSyles } from './vertical-bar-chart-loading-animation.styles';
const getClassNames = classNamesFunction();
export const VerticalBarChartLoadingAnimationBase = (props) => {
    const classNames = getClassNames(getverticalBarChartAnimationSyles, {
        theme: props.theme,
    });
    return (React.createElement("div", { className: classNames.root },
        React.createElement("div", { className: classNames.loadingBar },
            React.createElement("div", { className: classNames.first }),
            React.createElement("div", { className: classNames.second })),
        React.createElement("div", { className: classNames.loadingBar },
            React.createElement("div", { className: classNames.first }),
            React.createElement("div", { className: classNames.second })),
        React.createElement("div", { className: classNames.loadingBar },
            React.createElement("div", { className: classNames.first }),
            React.createElement("div", { className: classNames.second })),
        React.createElement("div", { className: classNames.loadingBar },
            React.createElement("div", { className: classNames.first }),
            React.createElement("div", { className: classNames.second }))));
};
//# sourceMappingURL=vertical-bar-chart-loading-animation.base.js.map